module.exports = __webpack_public_path__ + "static/article-2-5a696c91f38cea1ac0ab28326dbf46d1.jpg";